<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="角色名字" prop="userRoleName">
      <a-input v-model="form.userRoleName" placeholder="请输入角色名字" />
    </a-form-model-item>

    <a-form-model-item label="角色状态" prop="status">
      <a-radio-group v-model="form.status">
        <a-radio :value="1"> 启用 </a-radio>
        <a-radio :value="-1"> 停用 </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="默认角色" prop="isDefault" v-show="false">
      <a-radio-group v-model="form.isDefault">
        <a-radio :value="-1"> 否 </a-radio>
        <a-radio :value="1"> 是 </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="备注" prop="remark">
      <a-textarea v-model="form.remark" placeholder="请输入备注" />
    </a-form-model-item>

    <a-form-model-item label="菜单" prop="menus">
      <a-tree
        style="max-height: 340px; overflow: auto"
        v-if="treeData.length > 0"
        defaultExpandAll
        rowKey="menuId"
        checkable
        checkStrictly
        :replaceFields="{ title: 'menuName', key: 'menuId', value: 'menuId', children: 'children' }"
        :tree-data="treeData"
        @check="onCheckChange"
        v-model="form.menus"
      >
      </a-tree>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '创 建' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { createRoleApi, updateRoleApi, queryRoleByIdApi } from '@/api/System/Role'
import { queryMenuApi } from '@/api/System/Menu'
import { menuList2Tree } from '@/utils/'

export default {
  data() {
    return {
      form: {
        userRoleId: '',
        userRoleName: '',
        status: 1,
        remark: '',
        orderNum: 1,
        isDefault: -1,
        menus: []
      },
      rules: {
        userRoleName: [{ required: true, message: '菜单名称必填', trigger: ['change', 'blur'] }]
      },
      treeData: []
    }
  },

  props: ['formModel'],
  created() {
    if (this.formModel) {
      this.queryRoleById(this.formModel.userRoleId)
      this.checkedKeys = this.formModel.menus
    }
    this.getTreeData()
  },

  methods: {
    normalizer(node) {
      return {
        id: node.menuId,
        label: node.menuName,
        children: node.children
      }
    },
    onCheckChange({ checked }) {
      this.form.menus = checked
    },

    //生产表单数据
    getPostData() {
      let postData = { ...this.form }
      postData.menus = [...this.form.menus].map((item) => {
        return {
          menuId: item
        }
      })
      return postData
    },

    //根据id获取角色信息
    async queryRoleById(userRoleId) {
      const res = await queryRoleByIdApi({ userRoleId, needMenu: true })
      const { code, msg, extra } = res
      if (code == '200') {
        this.form = { ...extra.userRole }
        let menus = extra.userRole.menus.map((item) => item.menuId)
        this.form.menus = menus
      } else {
        this.$message.error(msg)
      }
    },

    //修改菜单
    async updateRole() {
      const res = await updateRoleApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    async getTreeData() {
      let query = {
        status: 1
      }
      let res = await queryMenuApi(query)
      let { code, msg, data } = res
      if (code == '200') {
        this.treeData = menuList2Tree(data)
      } else {
        this.$message.error(msg)
      }
    },

    //添加菜单
    async createRole() {
      const res = await createRoleApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    resetForm() {
      this.$refs.form.resetFields()
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateRole()
          } else {
            this.createRole()
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
div {
}
</style>
